import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // Not border-input: that token is sized for text inputs and leaves an
      // unchecked box at ~1.4:1, under the 3.0 WCAG wants for a control
      // boundary. See --fx-s-control-border in portal-brand.css.
      // NOT `rounded-sm`. This is Tailwind v4, where that resolves to
      // `var(--radius-sm)`, and our theme sets it to 8px (index.css:49) for
      // cards and inputs. On a 16px box an 8px radius is exactly half the
      // side — a perfect CIRCLE — so every checkbox in the portal read as a
      // radio button, which says "pick one of these" rather than "on/off".
      // Reported on the invoice Adenda card. Explicit px, because the shape of
      // a 16px control cannot follow a token tuned for 12-18px surfaces.
      "peer h-4 w-4 shrink-0 rounded-[4px] border border-[var(--fx-s-control-border)] ring-offset-background",
      "transition-colors duration-[var(--fx-dur-fast)] ease-[var(--fx-ease)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary",
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-3 w-3" strokeWidth={2.5} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
